import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    maxWidth: '300px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #2E2972',
    borderRadius: '999px',
    padding: '0 18px',
    background: theme.palette.background.default,
    transition: '0.2s ease',
    '&:focus-within': {
      border: '2px solid #2E2972'
    }
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: '28px',
    marginRight: '10px',
    flexShrink: 0
  },
  input: {
    flex: 1,
    '& input': {
      fontSize: '18px',
      color: theme.palette.secondary.dark
    },
    '& input::placeholder': {
      opacity: 0.8,
      color: theme.palette.grey[300]
    }
  },
  clearButton: {
    padding: 4,
    marginLeft: '8px',
    color: theme.palette.primary.contrastText,
    flexShrink: 0
  }
}))
